import moment from "moment";

export const CurrentCultureDateFormat = "M/d/yyyy";

export function findKeyByKeyName(obj: object, keyName: string) {
    return Object.keys(obj).find(x => x === keyName);
};

export const FormatDateToUserLocale = (value: any, format: any) => {
  //console.log('Common-FormatDateToUserLocale');
  const dateFormat = CurrentCultureDateFormat.toUpperCase();

  if (typeof value === 'string' && value.indexOf('T') !== -1) {
    return moment(value.split('T')[0]).format(dateFormat);
  }

  return moment(value, dateFormat).format(format || dateFormat);

};

export const getSystemAttendanceTypeId = (SystemAttendanceType: any) => {
 // console.log('Common-getSystemAttendanceTypeId');
  switch (SystemAttendanceType) {
    case 'Attendance':
      return "D5E53B7F-3489-4359-9B8E-808143827629";
    case 'Break':
      return "36D3465F-B775-4E36-A00E-A3B5C3AE78D1";
    default:
      return "";
  }
};

export const convertSecondIntoHoursMinutes = (seconds: any) => {
  //console.log('Common-convertSecondIntoHoursMinutes');
  let hours = "";
  let minutes = "";
  let hrs = Math.floor(seconds / 3600);
  seconds -= hrs * 3600;
  let mnts = Math.floor(seconds / 60);
  seconds -= mnts * 60;

  if (hrs < 10) {
    hours = "0" + hrs;
  } else {
    hours = String(hrs);
  }

  if (mnts < 10) {
    minutes = "0" + mnts;
  } else {
    minutes = String(mnts);
  }

  const convertedDuration = hours + ":" + minutes;
  return convertedDuration;
};

export const formatDateToTime = (value: any, meridium: any) => {
  let setFormat = '';

  if (value !== null) {
    setFormat = meridium === 0 ? 'HH:mm A' : 'HH:mm';
  } else {
    // Uncomment the line below if you want to handle undefined values
    // return (value !== undefined ? moment(value.split('+')[0]).format(setFormat) : '00:00');
  }

  return (value !== undefined && value !== null) ? moment(value.split('+')[0]).format(setFormat) : '00:00';
};


export const format12HoursOnly = (value: any, meridium: number) => {
  let setFormat = '';
  if (meridium === 0) {
    setFormat = 'hh:mm A';
  } else if (meridium === 1) {
    setFormat = 'hh:mm A';
    // setFormat = 'HH:mm';
  }
  // return value ? moment(value.split('+')[0]).format(setFormat) : '00:00';
  return value ? moment.parseZone(value).format(setFormat) : '00:00';
};